import createKeccakHash from 'keccak';
export const keccak256 = (data, encoding) => {
  return createKeccakHash('keccak256').update(data, encoding).digest();
};
export const toBuffer = (data, encoding) => {
  if (!encoding) {
    if (data.startsWith('0x')) {
      return Buffer.from(data.substring(2), 'hex');
    }

    return Buffer.from(data, 'hex');
  }

  return Buffer.from(data, encoding);
};
//# sourceMappingURL=buffer.js.map